;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

// Fired (fire-and-forget) when a visitor hits the messaging-not-available
// dialog. The backend re-checks messageability and emails the provider at
// most once per 30 days; the response is always { boolean: true }.
const recordProviderContactAttempt = gql`
  mutation recordProviderContactAttempt($iProviderId: Int!) {
    recordProviderContactAttempt(input: { iProviderId: $iProviderId }) {
      boolean
    }
  }
`

export default recordProviderContactAttempt
